<div
  *ngIf="!loading"
  class="p-fluid">
  <p class="font-bold text-lg">Вы действительно хотите удалить клиента?</p>
  <p class="mt-2 text-gray-400">Выберите клиента, к которому перейдут все дела удаленного клиента</p>

  <div class="field mt-3">
    <label class="font-medium required-field">Клиент</label>
    <crm-single-select
      [options]="clients"
      [(selectedItem)]="client"
      scrollHeight="250px"
      appendTo="body"></crm-single-select>
  </div>
</div>

<div
  *ngIf="!loading"
  class="flex justify-content-end gap-3 mt-5">
  <crm-button
    icon="pi pi-times"
    label="Отмена"
    styleClass="p-button-danger p-button-outlined"
    (onClick)="ref?.close()"></crm-button>

  <crm-button
    icon="pi pi-check"
    label="Удалить"
    styleClass="p-button-success"
    [disabled]="!client"
    (onClick)="ref?.close(client)"></crm-button>
</div>

<crm-spinner *ngIf="loading"></crm-spinner>
